import React from 'react';
import PropTypes from 'prop-types';
import isCustomField from '../../../helpers/isCustomField';
import { ColumnSettingsType } from '../../../interfaces/guest';
import { StringOrNumberType } from '../../../interfaces';
import GuestFieldValue from '../GuestFieldValue';
import CustomFieldValue from '../CustomFieldValue';
import HouseholdMemberChanges from '../HouseholdMemberChanges';
import LineChange from '../LineChange';

const ColumnChanges = ({ oldVal, newVal, action, colSettings }) => {
  const { label, name, fieldType } = colSettings;
  const FieldValue = isCustomField(name) ? CustomFieldValue : GuestFieldValue;

  if (name === 'othersHousehold')
    return (
      <HouseholdMemberChanges
        type={fieldType}
        label={label}
        oldVal={oldVal}
        newVal={newVal}
      />
    );

  if (name === 'profilePicture' || fieldType === 'file') {
    return (
      <LineChange>
        {!oldVal ? '- Set' : '- Changed'} {`"${label}" `}
        <strong>
          <FieldValue value={newVal} colSettings={colSettings} />
        </strong>
      </LineChange>
    );
  }

  if (action === 'create' || !oldVal)
    return (
      <LineChange>
        {`- Set "${label}" to `}
        <strong>
          <FieldValue value={newVal} colSettings={colSettings} />
        </strong>
      </LineChange>
    );

  return (
    <LineChange>
      {`- Changed "${label}" from `}
      <strong>
        <FieldValue value={oldVal} colSettings={colSettings} />
      </strong>
      {' to '}
      <strong>
        <FieldValue value={newVal} colSettings={colSettings} />
      </strong>
    </LineChange>
  );
};

ColumnChanges.propTypes = {
  oldVal: StringOrNumberType.isRequired,
  newVal: StringOrNumberType.isRequired,
  action: PropTypes.string.isRequired,
  colSettings: ColumnSettingsType.isRequired
};

export default ColumnChanges;
